<template>
    <div>
      <v-card class="grey lighten-3 pl-2 pr-2 card-r">

      <v-flex xs12 lg6 class="ma-auto pa-3">
              <v-text-field solo append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
         </v-flex>
        <v-data-table class="no-shadow card-r" v-bind:headers="headers" v-bind:items="items" v-bind:search="search" v-bind:pagination="pagination" hide-actions>
            <template slot="headers" slot-scope="props">
                <tr>
                    <th class="textColor font-weight-bold" v-for="(header, index) in props.headers" :key="header.text"
                        :class="['column', 'subheading' , index === 0? 'text-xs-left': 'text-xs-left']">
                        {{ header.text }}
                    </th>
                    <th>
                    </th>
                </tr>
            </template>
            <template class="body-2" slot="items" slot-scope="props">
                <td  v-for="(header, index) in headers" :key="index"
                     :class="[ index === 0? 'text-xs-left': 'text-xs-left', 'body-2']" v-if="header.value!==''">
                    {{renderData(props.item, header)}}

                </td>
                <td class="text-xs-center pa-0">
                    <!-- <v-btn icon>
                  <v-icon small  class="" @click.native="$emit('login',props.item.club_Id)">input</v-icon>
                    </v-btn> -->
                   <!-- <v-btn icon>
                        <v-icon small class=""  @click.native="$emit('view',props.item.club_Id)" color="green">visibility</v-icon>
                    </v-btn>-->
                    <!-- <v-btn class="teal" fab small dark @click.native="$emit('view', props.item)">
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn class="cyan" fab small @click.native="$emit('login', props.item)">
                      <v-icon>delete</v-icon>
                    </v-btn> -->
                </td>
            </template>
            <template slot="no-data">
     <span >
        <p class="pt-2 blue--text subheading">   <v-icon medium class="blue--text" >info</v-icon>Nothing to display here</p>
      </span>
            </template>
        </v-data-table>
        <div class="text-xs-center pt-2" v-if="isNotEmpty">
            <v-pagination v-model="pagination.page" :length="pagination.pages" :total-visible="5" circle></v-pagination>
        </div>
      </v-card>
    </div>
</template>
<script>
	/* eslint-disable */
	export default {
		props: {
			headers: '',
			items: '',
			pagination: '',
		},
		data () {
			return {
        search: "",
        actions:["pending","Processing","Done"]
			}
		},
		methods: {
			renderData: (item, header) => {
        if(header.value=='class_payment'){
        }
				let val = "";
				if (header.value.includes('.')) {
          const vals = header.value.split('.')
          if(item[vals[0]]!=null){
            val = vals.reduce((acc, val) => acc[val], item)
          }else{
            val="-"
          }
				} else {
					val = item[header.value]
				}
				if (typeof val === "boolean") {
					val = val ? "Yes" : "No";
				}
				return val;
      },
      changestatus(adminId,action){
        console.log(adminId,action)
      }
		},
		computed: {
			isNotEmpty () {
				return this.items && this.items.length > 0;
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/TableWithoutView.vue